const Team = ({ team, boffset }) => {
    /*const label = note.important
      ? 'make not important' : 'make important'*/

    const first_start_min = 60*13
  
    const min_to_hhmmss = (mins) => {
      const hrs = Math.floor(mins / 60)
      const min = Math.floor(mins - hrs*60)
      const sec = Math.floor((mins % 1)*60)

      return `${hrs}:${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`
    }

    const start_time = (offset) => {
      const diff = boffset - offset

      const stime = first_start_min + diff

      return min_to_hhmmss(stime)
    }


    return (
      <tr>
        <td>{team.team_name}</td>
        <td>{team.r1.name}</td>
        <td>{team.r2.name}</td>
        <td>{team.r3.name}</td>
        <td>{start_time(team.offset)}</td>
        <td>{(boffset-team.offset > 0.001) ? `+${min_to_hhmmss(boffset-team.offset)}` : ""}</td>
      </tr>
    )
  }
  
  export default Team